import { CompanyScope } from 'api/admin/userPermissions/types'

export function formatPrivilegeUserLabel(user: {
  id: number
  name: string | null
}): string {
  return user.name ? `${user.name} (${user.id})` : String(user.id)
}

export function formatCompanyScopeLabel(scope: CompanyScope): string {
  if (scope.allCompanies) {
    return 'All companies'
  }
  if (scope.company != null) {
    return `${scope.company.name} (${scope.company.id})`
  }
  if (scope.companyGroup != null) {
    return `Group: ${scope.companyGroup.name} (${scope.companyGroup.id})`
  }
  return 'Unknown scope'
}
